import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";

const PreguntasComunicacionReportes = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasComunicacionReportes();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Comunicación y reportes (2/6)"
			opciones={[
				{ key: "informaNovedadesOIncidencias", label: "Informa novedades o incidentes con claridad y a tiempo" },
				{ key: "completaYEntregaCorrectamenteHojasdeConformidad", label: "Completa y entrega correctamente hojas de conformidad, rendición de viáticos" },
				{ key: "mantieneActitudRespetuosaYColaborativa", label: "Mantiene una actitud respetuosa y colaborativa con el equipo de trabajo" },
				{ key: "liquidaOportunamenteRendiciondeViaticos", label: "Liquida oportunamente la rendición de viaticos y depósitos de los sobrantes" }
			]}
		/>
	);
};

export default PreguntasComunicacionReportes;
